class MarqueesApi {
    checkStatus(response) {
        switch (response.status) {
            case 500: //Error 500 del Servidor
                throw new Error(`${response.status} - Server Error!`);
                break;
            default:
                break;
        }
    }

    //Listar Marquesinas
    async listMarquees() {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}marquesinas/listar?id_clinica=${sessionStorage.getItem('id_clinica')}`, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            'Content-Type': 'application/json'
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            return null;
        });
        return datos;
    }

    //Eliminar Marquesina
    async deleteMarquees(marquees) {
        let deleted;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}marquesinas/delete`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body:JSON.stringify({id_marquesina:marquees.id_marquesina})
        }).then(response => {
            this.checkStatus(response);
            deleted = true;
            return true;
        }).catch((error) => {
            console.log(error);
            deleted = false;
            return false;
        });
        return deleted;
    }

}

export default new MarqueesApi();